import { tarslogs, TarslogsVue, setupAutoCapture } from '@tarslogs/client'
import type { App } from 'vue'

const TARSLOGS_URL = import.meta.env.VITE_TARSLOGS_URL
const TARSLOGS_PROJECT_ID = import.meta.env.VITE_TARSLOGS_PROJECT_ID
const TARSLOGS_API_KEY = import.meta.env.VITE_TARSLOGS_API_KEY

export const tarslogsEnabled = !!(TARSLOGS_URL && TARSLOGS_PROJECT_ID && TARSLOGS_API_KEY)

export function installTarslogs(app: App): void {
  if (!tarslogsEnabled) return

  tarslogs.init({
    url: TARSLOGS_URL!,
    projectId: TARSLOGS_PROJECT_ID!,
    apiKey: TARSLOGS_API_KEY!,
    environment: import.meta.env.MODE,
    version: __COMMIT_HASH__,
    rateLimitPerMinute: 30,
    debug: import.meta.env.DEV,
  })

  // Vue error handler
  app.use(TarslogsVue, { client: tarslogs })

  // Global auto-capture (window.onerror, unhandledrejection)
  setupAutoCapture(tarslogs)
}

export { tarslogs }
